import { MaterialCommunityIcons } from '@expo/vector-icons'
import React from 'react'
import { Pressable } from 'react-native'

interface CheckBoxProps{
  isChecked: boolean,
  onPress: () => void,
}

const Checkbox = ( props: CheckBoxProps) => {
  const {onPress, isChecked} = props
  
  const name = props.isChecked ? 'checkbox-marked' : 'checkbox-blank-outline'
  return (
    <Pressable onPress={onPress} /*style={{ flexDirection: 'row' }}*/>
      <MaterialCommunityIcons 
        name={name}
        size={24}
        color= '#FF2828'
      />
    </Pressable>
  )
}

export default Checkbox
